import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import './kycstyle.css';
import moment from "moment";
import HeaderCommon from './../HeaderComponent/HeadeCommon';
import ContentLoader from 'react-content-loader';
import Menu from "../MenuComponent/Menu";
import FooterComponet from "../FooterComponent/FooterComponet";
import { v4 as uuidv4 } from 'uuid';
import biometry from "./biometry";
import { store } from "../../redux/store";
import XMLParser from 'react-xml-parser';
import * as Spinner from 'react-spinkit';
import { setBiometricDtaCaptureStatus } from "../../redux/retailer-kyc-details/retailer-kyc-details.action";
const httpClient = axios.create();
class KycProcess extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            personalInfo: '',
            fullName: '',
            mobile: '',
            panNo: '',
            aadhaar: '',
            aadhaarErr: '',
            roId: '',
            otpErrMsg: '',
            verifyErrMsg: '',
            verifyOtpEnable: 'hidden',
            deviceConnectStatus: 'LOADING',
            progress: ''

        }
    }


    componentDidMount() {
        store.dispatch(setBiometricDtaCaptureStatus(''));
        // this.getSessionDetails();
        this.getProfile();
        var status = biometry.captureDeviceInfoOnLoad();
        this.setState({
            deviceConnectStatus: status
        })
    }

    getSessionDetails = () => {
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id
        };

        httpClient.get('/api/v1/retailer/onboard/session/'
            // + this.props.registerRetailerResponse.sessionId
            + '6defd38d-57f2-41f7-9ed8-cf11c7d64cbc'
            , { headers }
        ).then((response) => {
            console.log('session Id retailer response' + JSON.stringify(response.data));
            if (response.data.personalInfo != null) {
                this.setState({
                    fullName: response.data.personalInfo.fname + ' ' + response.data.personalInfo.lname,
                    mobile: response.data.personalInfo.mobile
                })
            }




        }).catch(error => {
            alert(error.message);
        

        });
    }

    getProfile = () => {
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id
        };

        httpClient.get('/api/v1/retailer/get/'
            // +this.props.roId
            // + this.props.roResponse.retailerId
            + '624080222133154'
            , { headers }
        ).then((response) => {
            console.log('get Profile Response' + JSON.stringify(response.data));
            if (response.data != null) {
                this.setState({
                    roId: response.data.id
                })
                if (response.data.personalInfo != null) {
                    this.setState({
                        fullName: response.data.personalInfo.fname + ' ' + response.data.personalInfo.lname,
                        mobile: response.data.personalInfo.mobile
                    })
                }
                var docs = [];
                if (response.data != null) {
                    if (response.data.kycInfo != null) {
                        docs = response.data.kycInfo.docs;
                    }
                }
                if (docs.length > 0) {

                    this.setState({
                        docs: docs
                    })
                    docs.map(doc => {
                        if (doc.type == 'PAN_CARD') {
                            this.setState({
                                panNo: doc.id,
                            })


                        }

                    })

                }
            }
        }).catch(error => {
            alert(error.message);

        });
    }
    componentWillUnmount() {
    }
    registerKycAndGetOtp = () => {
        this.setState({
            otpErrMsg: '',
            progress: 'loading-otp'
        })
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        httpClient.post('/api/v1/kyc/register/' + this.state.roId, '',
            { headers }
        ).then((response) => {
            console.log('registerKycAndGetOtp Response' + JSON.stringify(response.data));

            if (response.data.response.success == true) {
                this.setState({
                    verifyOtpEnable: 'enabled',
                    progress: 'completed'
                })
            } else {
                this.setState({
                    otpErrMsg: 'Something went wrong',
                    progress: 'completed'
                })
            }

        }).catch(error => {
            this.setState({
                otpErrMsg: 'Something went wrong',
                progress: 'completed'
            })


        });
    }

    enterOtp = (event) => {
        this.setState({
            otp: event.target.value
        })

    }

    verifyOtp = () => {
        this.setState({
            verifyErrMsg: '',
            progress: 'loading-verify'
        })
        var header = {
            msgType: "CREATE_ORDER",
            service: "KYC",
            src: "register-retailer",
            dst: "register-retailer",
            channel: "API",
            requesterId: this.props.clientRequesterId,
            requestId: uuidv4(),
            traceId: uuidv4(),
        }
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        var request = {
            header: header,
            agentId: this.state.roId,
            otpRef: '',
            otp: this.state.otp
        }

        httpClient.post('/api/v1/kyc/verify/' + this.state.roId, request,
            { headers }
        ).then((response) => {
            console.log('verify Response' + JSON.stringify(response.data));
            if (response.data.response.success == true) {
                this.setState({
                    verifyOtpEnable: 'proceesToKyc',
                    progress: 'completed'
                })
            } else {
                this.setState({
                    verifyErrMsg: 'Something went wrong',
                    progress: 'completed'
                })
            }

        }).catch(error => {
            this.setState({
                verifyErrMsg: 'Something went wrong',
                progress: 'completed'
            })


        });
    }


    captureFingerPrint = (event) => {
        event.preventDefault();

        biometry.captureFingerPrint('');

    }

    submitKycValdation = () => {
        if (this.state.aadhaar != '' &&
            (this.state.aadhaar.length == 12 || this.state.aadhaar.length == 16)) {
            return true;
        } else {
            this.setState({
                aadhaarErr: 'Please enter correct aadhaar/VID'
            })
            return false;
        }
    }

    submitKyc = (event) => {
        event.preventDefault();

        if (this.submitKycValdation() == true) {
            var biometricData = atob(this.props.kycBiometricData);
            var biometricDataToJson = new XMLParser().parseFromString(biometricData);


            // console.log(JSON.stringify(biometricDataToJson));
            var serialNum = '';
            var sessionKey = '';
            var hmacXml = '';
            var dataXml = '';
            var type = '';
            var certExp = '';
            var version = '';
            var timestamp = '';


            biometricDataToJson.children.map(child => {
                if (child.name == 'DeviceInfo') {
                    version = child.attributes.rdsVer;
                    // meta = {
                    //     udc: child.attributes.dc,
                    //     rdsId: child.attributes.rdsId,
                    //     dpId: child.attributes.dpId,
                    //     dc: child.attributes.dc,
                    //     mi: child.attributes.mi,
                    //     mc: child.attributes.mc
                    // }
                    // deviceVersion = child.attributes.rdsVer;
                    var chMap = child.children;
                    var dataMap = [];

                    chMap.map(data => {
                        if (data.name == 'additional_info') {
                            dataMap = data.children;
                        }
                    })
                    dataMap.map(data => {
                        alert(JSON.stringify(data))
                        if (data.attributes.name == 'srno') {
                            serialNum = data.attributes.value;
                        }
                        if (data.attributes.name == 'ts') {
                            timestamp = data.attributes.value;
                        }
                    })

                }




                if (child.name == 'Skey') {
                    // skey = {
                    //     ci: child.attributes.ci,
                    //     value: child.value
                    // }
                    sessionKey = child.value;
                }
                if (child.name == 'Hmac') {
                    hmacXml = child.value
                }
                if (child.name == 'Data') {
                    // data = {
                    //     type: child.attributes.type,
                    //     value: child.value
                    // }
                    dataXml = child.value;
                    type = child.attributes.type;
                }

            })

            const headers = {
                'Authorization': 'Bearer ' + this.props.token,
                'client-id': this.props.agentInfo.id,
                'role': this.props.clientRole
            }


            var bioDevice = {
                serialNum: serialNum,
                sessionKey: sessionKey,
                hmacXml: hmacXml,
                dataXml: dataXml,
                type: type,
                certExp: certExp,
                version: version,
                timestamp: timestamp
            }

            var header = {
                msgType: "CREATE_ORDER",
                service: "KYC",
                src: "register-retailer",
                dst: "register-retailer",
                channel: "API",
                requesterId: this.props.clientRequesterId,
                requestId: uuidv4(),
                traceId: uuidv4(),
            }

            var request = {
                header: header,
                agentId: this.state.roId,
                aadhaar: '409136448609',
                bioDevice: bioDevice,
                biometricData: this.props.kycBiometricData,
                capturedTemplate: ''
            }





            httpClient.post('/api/v1/kyc/submit/' + this.state.roId, request,
                { headers }
            ).then((response) => {
                console.log('submit Response' + JSON.stringify(response.data));
                if (response.data.response.success == true) {
                    this.setState({
                        // verifyOtpEnable: 'proceesToKyc',
                        progress: 'completed'
                    })
                } else {
                    this.setState({
                        // verifyErrMsg: 'Something went wrong',
                        progress: 'completed'
                    })
                }

            }).catch(error => {
                this.setState({
                    // otpErrMsg: 'Something went wrong',
                    progress: 'completed'
                })
                // alert(error.message);
        
            });


            // var biometricDeviceInfo = {
            //     Hmac: Hmac,
            //     reqid: uuidv4(),
            //     refcode: this.state.refNo,
            //     tid: uuidv4(),
            //     roid: this.props.phone,
            //     devicever: deviceVersion,
            //     serialno: serialNo,
            //     meta: meta,
            //     skey: skey,
            //     data: data
            // }
        }



    }

    enterAadhaar = (event) => {
        this.setState({
            aadhaarErr: '',
            aadhaar: event.target.value
        })
    }

    // @POST(" /api/v1/kyc/submit/{agentId}")
    // Call<FullKycResponse> doKyc(@Body FullKycRequest request,  @Header("Authorization") String token, @Path("agentId") String agentId);
    // public class FullKycRequest {
    //     private RequestHeader header;
    //     private String agentId;
    //     private String aadhaar;
    //     private BiometricDeviceData bioDevice;
    //     private String biometricData;
    //     private String capturedTemplate;

    render() {

        return (

            <div>
                {/* <HeaderCommon />
                <Menu /> */}

                <div class="mid-contant1">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="head1">
                                    <h2>KYC Process</h2>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="kycform">
                                    <div class="row mb-3">
                                        <div class="col-12 col-lg-7">
                                            <form>
                                                <div class="row">
                                                    <div class="col-12 col-md-6">
                                                        <div class="form-floating">
                                                            <input type="text" class="form-control" id="firsname" placeholder="Enter name" value={this.state.fullName}
                                                                readOnly />
                                                            <label for="firsname">Full Name</label>
                                                        </div>
                                                    </div>

                                                    <div class="col-12 col-md-6">
                                                        <div class="form-floating">
                                                            <input type="text" class="form-control" id="mobile" placeholder="Enter mobile no." value={this.state.mobile}
                                                                readOnly />
                                                            <label for="mobile">Mobile number</label>
                                                        </div>
                                                    </div>

                                                    <div class="col-12 col-md-6">
                                                        <div class="form-floating">
                                                            <input type="number" class="form-control" id="lastname" placeholder="Enter Aadhaar" value={this.state.aadhaar}
                                                                onInput={(e) => e.target.value = e.target.value.slice(0, 16)}
                                                                onChange={this.enterAadhaar} />
                                                            <label for="lastname">Aadhaar Number / VID</label>
                                                        </div>
                                                        {this.state.aadhaarErr != '' &&
                                                            <div class='valid-error'>
                                                                {this.state.aadhaarErr}</div>}
                                                    </div>

                                                    <div class="col-12 col-md-6">
                                                        <div class="form-floating">
                                                            <input type="text" class="form-control" id="pan" placeholder="Enter PAN" value={this.state.panNo}
                                                                readOnly />
                                                            <label for="pan">PAN Number</label>
                                                        </div>
                                                    </div>

                                                    <div class="col-12 col-md-6">
                                                        <div class="form-floating">
                                                            {(this.state.verifyOtpEnable == 'hidden' ||
                                                                this.state.verifyOtpEnable == 'enabled') &&
                                                                <input type="text" class="form-control" id="otp" placeholder="Verify OTP"
                                                                    onInput={(e) => e.target.value = e.target.value.slice(0, 6)}
                                                                    value={this.state.otp}
                                                                    readOnly={this.state.verifyOtpEnable == 'hidden' && true}
                                                                    onChange={this.enterOtp}
                                                                />
                                                            }
                                                            {(this.state.verifyOtpEnable == 'hidden' ||
                                                                this.state.verifyOtpEnable == 'enabled') &&
                                                                <label for="otp">Verify OTP</label>
                                                            }
                                                            {this.state.verifyOtpEnable == 'enabled' &&
                                                                <button type="button" class="otpbtn" id="getotp"
                                                                    disabled={this.state.progress == 'loading' && true} onClick={this.verifyOtp}>Verify</button>
                                                            }
                                                            {this.state.verifyOtpEnable == 'hidden' &&
                                                                <button type="button" class="otpbtn" id="getotp"
                                                                    disabled={this.state.progress == 'loading' && true} onClick={this.registerKycAndGetOtp}>Get OTP</button>
                                                            }
                                                            {/* {this.state.verifyOtpEnable == 'proceesToKyc' &&
                                                                <button type="button" class="otpbtn" id="getotp" disabled>Verify</button>
                                                            } */}
                                                            {/* <button type="button" class="otpbtn" id="resend">Resend</button> */}


                                                            {this.state.verifyOtpEnable == 'proceesToKyc' &&
                                                                <div class='valid-success'>
                                                                    Otp Verified Successfully, proceed to Kyc</div>}
                                                        </div>

                                                        {this.state.progress == 'loading-otp' &&
                                                            <div class='valid-error'>
                                                                Sending otp.Please wait..</div>}
                                                        {this.state.progress == 'loading-verify' &&
                                                            <div class='valid-error'>
                                                                Verifying otp.Please wait..</div>}
                                                        {this.state.otpErrMsg != '' &&
                                                            <div class='valid-error'>
                                                                {this.state.otpErrMsg}</div>}
                                                        {this.state.verifyErrMsg != '' &&
                                                            <div class='valid-error'>
                                                                {this.state.verifyErrMsg}</div>}
                                                    </div>

                                                    <div class="col-12 mt-4">
                                                        <div class="form-check">
                                                            <input class="form-check-input" type="checkbox" value="" id="tnc" checked />
                                                            <label class="form-check-label tnc" for="tnc">By registering, you confirm that you accept our <a href="#">terms and conditions</a></label>
                                                        </div>
                                                    </div>



                                                    {this.state.deviceConnectStatus == 'READY' ?
                                                        <div class="col-12">
                                                            <div class="scanner connect"><i class="connect"></i> Biometric device connected, scan fingerprint of the customer for Aadhaar authentication</div>
                                                        </div> :
                                                        this.state.deviceConnectStatus == 'LOADING' ?
                                                            <div class="col-12 col-sm-6">
                                                                <div class="scanner connect"><i class="connect"></i> Checking Biometric status..Please wait</div>
                                                            </div> : this.state.deviceConnectStatus == 'ERROR' ?
                                                                <div class="col-12 col-sm-6">
                                                                    <div class="device"><i class="disconnect"></i> Biometric device not connected or Driver not installed!</div>
                                                                </div> :
                                                                <div class="col-12 col-sm-6">
                                                                    <div class="device"><i class="disconnect"></i> Biometric device not connected!</div>
                                                                </div>


                                                    }

                                                    {
                                                        this.state.verifyOtpEnable == 'proceesToKyc' ?
                                                            this.state.deviceConnectStatus == 'READY' ?
                                                                (this.props.kycBiometricDtaCaptureStatus != 'success' ?
                                                                    <div class="col-12">
                                                                        <button type="button" class="btn btn-primary" id="capturenow" onClick={this.captureFingerPrint}>Capture</button>
                                                                    </div>
                                                                    :
                                                                    <div class="col-12">
                                                                        <button type="submit" class="btn btn-primary" id="proceedAeps" onClick={this.submitKyc}>Proceed</button>
                                                                    </div>)
                                                                :
                                                                <div class="col-12">
                                                                    <button type="button" class="btn btn-primary" id="capturenow" disabled>Proceed</button>
                                                                </div>
                                                            : <div class="col-12">
                                                                <button type="button" class="btn btn-primary" disabled>Proceed</button>
                                                            </div>
                                                    }






                                                    {/* <div class="col-12">
                                                        <button type="button" class="btn btn-primary" id="capturenow" onClick={this.captureFingerPrint}>Capture</button>
                                                    </div>
                                                    <div class="col-12">
                                                        <button type="submit" class="btn btn-primary" id="proceedAeps" onClick={this.submitKyc}>Proceed</button>
                                                    </div> */}
                                                </div>
                                            </form>
                                        </div>

                                        <div class="col-12 col-lg-5 d-none d-lg-block">
                                            <div class="rightbanner"><img src="images/register.png" alt="Oxigen" class="img-fluid" /></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <FooterComponet />
                {this.state.deviceConnectStatus == 'LOADING' &&
                    <div className="loader">
                        <div className="loader-content">
                            <Spinner name="ball-spin-fade-loader" />
                            <div className="loader-message"> Checking Biometric status..Please wait </div>
                        </div>
                    </div>
                }
            </div>

        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { phone, agentInfo, token, clientRole,clientRequesterId},
        retailerKycReduce: { registerRetailerResponse, personalInfo, roResponse, kycBiometricDtaCaptureStatus, kycBiometricData, roId } }

) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, phone, agentInfo, token,clientRole, clientRequesterId,registerRetailerResponse, personalInfo, roResponse, kycBiometricDtaCaptureStatus, kycBiometricData, roId
});

export default connect(mapStateToProps, null)(KycProcess);
